import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { FormularioDialogService } from '../../../../auxiliares/servicios/formulario-dialog.service';
import { IConfigEventoUsuario, IQueryParam, IUsuario } from 'modelos/src';
import { Subscription } from 'rxjs';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';

import { AuxiliaresModule } from '../../../../auxiliares/auxiliares.module';
import {
  IColumnas,
  ICrearBoton,
} from '../../../../auxiliares/tabla/tabla.component';
import { estadoHtml, fechaCelda } from '../../../../auxiliares/tabla/celdas';
import {
  IFiltroTabla,
  IRegExpSearch,
} from '../../../../auxiliares/tabla/filtro/filtro.component';
import { DialogService } from '../../../../auxiliares/dialog/dialog.service';
import { ConfigEventoUsuarioService } from '../../../../auxiliares/servicios/http/config-evento-usuario.service';
import { HelperService } from '../../../../auxiliares/servicios/helper.service';
import { cronogramaUtcALocal } from '../../../../auxiliares/cronograma-utc.util';
import {
  CrearEditarConfigEventoUsuarioDialogComponent,
  IParamEventoUsuario,
} from '../crear-editar-config-evento-usuario-dialog/crear-editar-config-evento-usuario-dialog.component';
import { ParamsService } from '../../../../auxiliares/servicios/params.service';
import { Lista2Service } from '../../../../auxiliares/servicios/lista2.service';
import { ClienteJerarquiaService } from '../../../../auxiliares/servicios/cliente-jerarquia.service';
import { escaparHtml } from '../../../../auxiliares/html-seguro.util';

@Component({
  imports: [AuxiliaresModule],
  selector: 'app-listado-config-evento-usuario',
  templateUrl: './listado-config-evento-usuario.component.html',
  styleUrls: ['./listado-config-evento-usuario.component.scss'],
})
export class ListadoConfigEventoUsuarioComponent implements OnInit, OnDestroy {
  private clienteJerarquia = inject(ClienteJerarquiaService);
  private dialogService = inject(DialogService);
  private service = inject(ConfigEventoUsuarioService);
  private formularios = inject(FormularioDialogService);
  helper = inject(HelperService);
  private lista2 = inject(Lista2Service);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private paramsService = inject(ParamsService);

  //// Tabla nueva
  public name = 'ListadoConfigEventoUsuarioComponent';
  public datos?: IConfigEventoUsuario[];
  public columnas?: IColumnas<IConfigEventoUsuario>[];
  public totalCount = 0;
  public botonCrear: ICrearBoton = {
    mostrar: this.helper.tienePermiso(
      'Administración - Crear eventos personalizados',
    ),
    tooltip: 'Crear configuración de notificación',
    color: 'primary',
    icon: 'add',
    accion: () => this.crear(),
    tipo: 'material',
  };
  public search: IRegExpSearch = {
    fields: ['nombre'],
  };

  public agrupacion: IFiltroTabla = {
    elementos: [
      { label: 'Global', value: 'Global' },
      { label: 'Grupo', value: 'Grupo' },
      { label: 'Entidad', value: 'Entidad' },
    ],
    filter: {
      field: 'agrupacion',
    },
    label: 'Agrupación',
    selectLabel: 'label',
    selectValue: 'value',
    tipo: 'select',
    rapido: true,
  };
  public cliente: IFiltroTabla = {
    filter: {
      field: 'idCliente',
    },
    label: 'Cliente',
    tipo: 'cliente-selector',
  };
  // Cliente en cuya jerarquía cuelga la entidad: el cliente elegido y toda su
  // descendencia.
  public ancestro: IFiltroTabla = {
    filter: {
      field: 'idsAncestros',
      incluirPropio: true,
    },
    label: 'En la jerarquía de',
    tipo: 'cliente-selector',
  };
  private activo: IFiltroTabla = {
    elementos: [],
    filter: {
      field: 'idEntidad',
    },
    label: 'Activo',
    selectLabel: 'identificacion',
    selectValue: '_id',
    tipo: 'ngselect-async',
    asyncFunction: 'activos',
    searchOn: ['identificacion'],
  };
  private alarma: IFiltroTabla = {
    elementos: [],
    filter: {
      field: 'idEntidad',
    },
    label: 'Alarma',
    selectLabel: 'nombre',
    selectValue: '_id',
    tipo: 'ngselect-async',
    asyncFunction: 'dispositivosAlarmas',
    searchOn: ['nombre'],
  };
  private vehiculo: IFiltroTabla = {
    elementos: [],
    filter: {
      field: 'idEntidad',
    },
    label: 'Vehículo',
    selectLabel: 'identificacion',
    selectValue: '_id',
    tipo: 'ngselect-async',
    asyncFunction: 'vehiculos',
    searchOn: ['identificacion'],
  };
  private luminaria: IFiltroTabla = {
    elementos: [],
    filter: {
      field: 'idEntidad',
    },
    label: 'Luminaria',
    selectLabel: 'identificacion',
    selectValue: '_id',
    tipo: 'ngselect-async',
    asyncFunction: 'luminarias',
    searchOn: ['identificacion'],
  };

  private categoria: IFiltroTabla = {
    elementos: [],
    filter: {
      field: 'idCategoriaEvento',
    },
    label: 'Categoría',
    selectLabel: 'nombre',
    selectValue: '_id',
    tipo: 'ngselect-async',
    asyncFunction: 'categoriaEventos',
    searchOn: ['nombre'],
  };
  private tipoEvento: IFiltroTabla = {
    elementos: [],
    filter: {
      field: 'idListadoCategoria',
    },
    label: 'Tipo de evento',
    selectLabel: 'nombre',
    selectValue: '_id',
    tipo: 'ngselect-async',
    asyncFunction: 'listadoCategorias',
    searchOn: ['nombre'],
  };
  private tipoEntidad: IFiltroTabla = {
    elementos: [
      { label: 'Activo', value: 'Activo' },
      { label: 'Vehículo', value: 'Vehiculo' },
      { label: 'Alarma', value: 'Alarma' },
      { label: 'Usuario', value: 'Usuario' },
      { label: 'Luminaria', value: 'Luminaria' },
    ],
    filter: {
      field: 'tipoEntidad',
    },
    label: 'Tipo de entidad',
    selectLabel: 'label',
    selectValue: 'value',
    tipo: 'select',
  };
  private activa: IFiltroTabla = {
    elementos: [
      { label: 'Sí', value: true },
      { label: 'No', value: false },
    ],
    filter: {
      field: 'activa',
    },
    label: 'Activa',
    selectLabel: 'label',
    selectValue: 'value',
    tipo: 'select',
    rapido: true,
  };

  public filtros: IFiltroTabla[] = [this.agrupacion];

  // QUERY+
  private populate = [
    {
      path: 'grupo',
      select: 'nombre',
    },
    {
      path: 'luminaria',
      select: 'identificacion idModeloDispositivo',
      populate: {
        path: 'modeloDispositivo',
        select: 'idCodigos',
        populate: {
          path: 'codigos',
          select: 'codigos',
        },
      },
    },
    {
      path: 'usuarios',
      select: 'usuario',
    },
    {
      path: 'activo',
      select: 'identificacion',
    },
    {
      path: 'alarma',
      select: 'nombre idModelo',
      populate: {
        path: 'modelo',
        select: 'idCodigos',
        populate: {
          path: 'codigos',
          select: 'codigos',
        },
      },
    },
    {
      path: 'condicion.activo.ubicacion.ubicacion',
      select: 'identificacion',
    },
    {
      path: 'categoriaEvento',
      select: 'nombre color',
    },
    {
      path: 'listadoCategoria',
      select: 'nombre',
    },
    {
      path: 'cliente',
      select: 'nombre',
    },
  ];

  public query: IQueryParam = {
    filter: JSON.stringify({}),
    page: 0,
    limit: +this.helper.getPageSize(this.name),
    populate: JSON.stringify(this.populate),
  };

  @Input() public params?: IParamEventoUsuario;

  // Listado Continuo
  public datos$?: Subscription;

  // ACCIONES
  public async crear(): Promise<void> {
    let res;
    if (this.params.crear === 'Dialog') {
      this.paramsService.setParams({ dialog: true, params: this.params });
      res = this.formularios.abrir(
        CrearEditarConfigEventoUsuarioDialogComponent,
        { tamano: 'grande' },
      );
    } else {
      this.paramsService.setParams({ dialog: false, params: this.params });
      const extras: NavigationExtras = {
        relativeTo: this.route,
      };
      this.router.navigate(['crear'], extras);
    }
    if (res) {
      res.afterClosed().subscribe(async (data: any) => {
        if (data) {
          await this.listar();
        }
      });
    }
  }

  public async editar(data: IConfigEventoUsuario) {
    let res;
    if (this.params.crear === 'Dialog') {
      this.paramsService.setParams({
        dialog: true,
        params: this.params,
        edit: data,
      });
      res = this.formularios.abrir(
        CrearEditarConfigEventoUsuarioDialogComponent,
        { tamano: 'grande' },
      );
    } else {
      this.params.alarma = data.alarma;
      this.paramsService.setParams({
        dialog: false,
        params: this.params,
        edit: data,
      });
      const extras: NavigationExtras = {
        relativeTo: this.route,
      };
      this.router.navigate(['editar', data._id], extras);
    }
    if (res) {
      res.afterClosed().subscribe(async (r: any) => {
        if (r) {
          await this.listar();
        }
      });
    }
  }

  public tipoIcono(dato: IConfigEventoUsuario): string {
    return dato.activa ? 'check' : 'cross';
  }

  public async cambiarEstado(dato: IConfigEventoUsuario): Promise<void> {
    const confirm = await this.dialogService.confirm(
      'Confirmá la acción',
      `¿${dato.activa ? 'Desactivar' : 'Activar'} la configuración?`,
    );
    if (confirm) {
      try {
        await this.service.update(dato._id!, { activa: !dato.activa });
        this.helper.notifSuccess(
          dato.activa ? 'Configuración desactivada' : 'Configuración activada',
        );
        await this.listar();
      } catch (error) {
        this.helper.notifError(error);
      }
    }
  }

  public async eliminar(dato: IConfigEventoUsuario): Promise<void> {
    const confirm = await this.dialogService.confirm(
      'Confirmá la acción',
      `¿Eliminar la configuración de notificación?`,
    );
    if (confirm) {
      try {
        await this.service.delete(dato._id!);
        await this.listar();
        this.helper.notifSuccess('Eliminación correcta');
      } catch (error) {
        this.helper.notifError(error);
      }
    }
  }

  // Listar

  public async listar(): Promise<void> {
    const filter = this.query.filter ? JSON.parse(this.query.filter) : {};
    filter.condicion = { $exists: true };
    // Excluir configs autogeneradas por el sistema (p.ej. "Seguimiento ambulancia").
    // Backend marca esDelSistema=true al crearlas automáticamente.
    filter.esDelSistema = { $ne: true };

    if (this.params.idEntidad) {
      filter['idEntidad'] = this.params.idEntidad;
    }
    if (this.params.idGrupo) {
      filter['idGrupo'] = this.params.idGrupo;
    }
    this.query.filter = JSON.stringify(filter);

    this.datos$?.unsubscribe();
    this.datos$ = this.lista2
      .configEventos(this.query, 30)
      .subscribe((data) => {
        this.totalCount = data.totalCount;
        this.datos = data.datos;
      });
  }

  private setColumnas() {
    const columnas: IColumnas<IConfigEventoUsuario>[] = [
      // Fecha
      {
        header: {
          label: 'Fecha de creación',
          sort: 'fechaCreacion',
          sortable: true,
        },
        row: {
          fecha: (dato) => dato.fechaCreacion,
          noData: 'Sin fecha',
        },
      },
      // Activa
      {
        header: {
          label: 'Activa',
          sortable: true,
          sort: 'activa',
        },
        row: {
          estado: (dato) =>
            dato.activa
              ? { texto: 'Activa', tono: 'ok', icono: 'toggle_on' }
              : { texto: 'Inactiva', tono: 'neutro', icono: 'toggle_off' },
        },
      },
      // Categoria de Evento
      {
        header: {
          label: 'Categoría',
        },
        row: {
          html: (dato) => {
            if (dato.categoriaEvento) {
              // Badge del color de la categoría con el nombre adentro
              return estadoHtml({
                texto: dato.categoriaEvento.nombre || '',
                tono: 'neutro',
                color: dato.categoriaEvento.color,
              });
            }
            return '';
          },
          noData: 'Sin categoría',
        },
      },
      // Tipo de Evento
      {
        header: {
          label: 'Tipo de evento',
        },
        row: {
          parse(dato) {
            if (dato?.listadoCategoria) return dato.listadoCategoria.nombre;
            else return '';
          },
          noData: 'Sin tipo de evento',
        },
      },
    ];

    // Tipo de Entidad
    if (!this.params?.tipoEntidad) {
      columnas.push({
        header: {
          label: 'Tipo de entidad',
          sortable: true,
        },
        row: {
          field: 'tipoEntidad',
          noData: 'Sin tipo',
        },
      });
    }

    columnas.push(
      // Agrupación
      {
        header: {
          label: 'Agrupación',
        },
        row: {
          field: 'agrupacion',
        },
      },
      // Nombre
      {
        header: {
          label: 'Nombre',
        },
        row: {
          html: (dato) => this.parseNombre(dato),
          noData: 'Sin entidad',
        },
      },
      // Condicion
      {
        header: {
          label: 'Condición',
        },
        row: {
          html: (dato) => this.parseCondicion(dato),
        },
      },
      // Usuarios
      {
        header: {
          label: 'Usuarios',
        },
        row: {
          html: (dato) => this.parseUsuarios(dato.usuarios),
          noData: 'No se notifica',
        },
      },
      // Medio
      // {
      //   header: {
      //     label: 'Medio',
      //   },
      //   row: {
      //     field: 'tipoEnvio',
      //   },
      // },
      // Frecuencia
      {
        header: {
          label: 'Frecuencia',
        },
        row: {
          html: (dato) => this.parseFrecuencia(dato),
          noData: 'Sin frecuencia',
        },
      },
      // Requiere atencion
      {
        header: {
          label: 'Requiere atención',
          sortable: true,
          sort: 'atender',
        },
        row: {
          // Es un dato de la configuración: Sí/No como texto
          parse: (dato) => (dato.atender ? 'Sí' : 'No'),
        },
      },
    );

    // Cliente
    if (HelperService.getTipoCliente() !== 'Final') {
      {
        columnas.push({
          header: {
            label: 'Cliente',
          },
          row: {
            html: (dato) => this.clienteJerarquia.htmlNombre(dato.cliente),
            tooltip: (dato) =>
              this.clienteJerarquia.tooltipJerarquia(dato.cliente),
            noData: 'Sin cliente',
          },
        });
      }
    }

    // Acciones
    columnas.push({
      header: {
        label: 'Acciones',
      },
      row: {
        acciones: [
          {
            tipo: 'material',
            color: 'primary',
            icon: 'edit',
            tooltip: 'Editar',
            click: (dato) => this.editar(dato),
            disabled: (dato) =>
              !this.helper.tienePermiso(
                'Administración - Editar eventos personalizados',
              ) || dato.categoriaEvento?.nombre === 'Seguimiento ambulancia',
          },
          {
            tipo: 'material',
            color: 'warn',
            icon: 'delete',
            tooltip: 'Eliminar',
            click: (dato) => this.eliminar(dato),
            disabled: (dato) =>
              !this.helper.tienePermiso(
                'Administración - Eliminar eventos personalizados',
              ) ||
              (!this.helper.esNivel0() &&
                dato.categoriaEvento?.nombre === 'Seguimiento ambulancia'),
          },
          {
            tipo: 'material',
            color: 'primary',
            icon: 'toggle_on',
            tooltip: 'Activar',
            oculta: (dato) => dato.activa,
            click: (dato) => this.cambiarEstado(dato),
            disabled: (dato) =>
              !this.helper.tienePermiso(
                'Administración - Editar eventos personalizados',
              ) || dato.categoriaEvento?.nombre === 'Seguimiento ambulancia',
          },
          {
            tipo: 'material',
            color: 'primary',
            icon: 'toggle_off',
            tooltip: 'Desactivar',
            oculta: (dato) => !dato.activa,
            click: (dato) => this.cambiarEstado(dato),
            disabled: (dato) =>
              !this.helper.tienePermiso(
                'Administración - Editar eventos personalizados',
              ) || dato.categoriaEvento?.nombre === 'Seguimiento ambulancia',
          },
        ],
      },
    });

    this.columnas = columnas;
  }

  private parseNombre(dato: IConfigEventoUsuario) {
    const grupo = dato.grupo?.nombre;

    switch (dato.agrupacion) {
      case 'Global': {
        return 'No aplica';
      }
      case 'Grupo': {
        return escaparHtml(grupo ?? '');
      }
      case 'Entidad': {
        switch (dato.tipoEntidad as any) {
          case 'Vehiculo':
          case 'Activo': {
            return escaparHtml(dato.activo?.identificacion ?? '');
          }
          case 'Alarma': {
            return escaparHtml(dato.alarma?.nombre ?? '');
          }
          case 'Luminaria': {
            return escaparHtml(dato.luminaria?.identificacion ?? '');
          }
          default: {
            return '';
          }
        }
      }
      default:
        return '';
    }
  }

  private parseUsuarios(d: IUsuario[]) {
    let str = '';
    for (const u of d) {
      str = str + `<div>${escaparHtml(u.usuario)}</div>`;
    }
    return str;
  }

  private parseFrecuencia(dato: IConfigEventoUsuario) {
    const frecuencia = dato.frecuencia;
    const generarSiNoSeCumple = dato.generarSiNoSeCumple;
    const generarSoloUnaVez = dato.generarSoloUnaVez;
    // El cronograma viene en UTC: se muestra en la hora local del usuario.
    const { dias, horaInicio, horaFin } = cronogramaUtcALocal({
      dias: dato.dias,
      horaInicio: dato.horaInicio,
      horaFin: dato.horaFin,
    });
    const validaDesde = dato.validaDesde;
    const validaHasta = dato.validaHasta;

    switch (frecuencia) {
      case 'Continua': {
        return 'Continuo';
      }
      case 'Cronograma': {
        if (dias?.length) {
          return `Días: ${dias.join(', ')} ${horaInicio} - ${horaFin}`;
        } else {
          return `Error en configuración de frecuencia`;
        }
      }
      case 'Continua en un periodo': {
        if (validaDesde && validaHasta) {
          let html = `Desde ${fechaCelda(validaDesde)} hasta ${fechaCelda(validaHasta)}`;
          if (generarSiNoSeCumple) {
            html += ' (Generar evento si no se cumple)';
          }
          if (generarSoloUnaVez) {
            html += ' (Generar evento solo una vez)';
          }
          return html;
        } else {
          return `Error en configuración de frecuencia`;
        }
      }
      case 'Unica': {
        return 'En cualquier momento 1 sola vez';
      }
    }

    return 'Error en configuración de frecuencia';
  }

  private parseCondicion(dato: IConfigEventoUsuario) {
    let html = '<div>';
    switch (dato.tipoEntidad as any) {
      case 'Vehiculo':
      case 'Activo': {
        // Condicion Ubicacion
        if (dato.condicion?.activo?.ubicacion?.idUbicacion) {
          const dentro = dato.condicion?.activo?.ubicacion?.dentro;
          const fuera = dato.condicion?.activo?.ubicacion?.fuera;
          if (dentro) {
            html += '<span class="label-primary">Dentro</span> ';
          }
          if (fuera) {
            html += '<span class="label-primary">Fuera</span> ';
          }

          const ubicacion =
            dato.condicion?.activo?.ubicacion?.ubicacion?.identificacion;
          if (ubicacion) html += escaparHtml(ubicacion);
          // html += `Dentro ${dentro ? 'Sí' : 'No'} `;
          // html += `Fuera ${fuera ? 'Sí' : 'No'} `;
        }
        // Condicion Velocidad
        if (dato.condicion?.activo?.velocidad) {
          const velocidad = dato.condicion?.activo?.velocidad['superior a'];
          const tiempoMinimo = dato.condicion?.activo?.velocidad?.tiempoMinimo;
          html += `Velocidad superior a ${velocidad} km/h`;
          if (tiempoMinimo) html += ` durante ${tiempoMinimo} seg`;
        }
        // Condicion Exceso de velocidad por calle
        if (dato.condicion?.activo?.excesoVelocidadCalle) {
          const exceso = dato.condicion.activo.excesoVelocidadCalle;
          html += `Exceso de velocidad según límite de la calle (tolerancia ${exceso.tolerancia ?? 10}%)`;
          if (exceso.tiempoMinimo)
            html += ` durante ${exceso.tiempoMinimo} seg`;
        }
        // Condicion Detenido
        if (dato.condicion?.activo?.detenido) {
          const detenido = dato.condicion?.activo?.detenido['mas de'];
          html += `Detenido más de ${detenido} minutos`;
        }
        // Condicion Estacionado (modo estacionamiento, creado desde la app mobile)
        if (dato.condicion?.activo?.estacionado) {
          const distancia =
            dato.condicion?.activo?.estacionado?.distanciaDeAviso;
          html += `Modo estacionamiento${distancia ? ` (aviso al moverse más de ${distancia} m)` : ''}`;
        }
        // Condicion Recorridos
        if (dato.condicion?.activo?.recorridos) {
          const recorridos = dato.condicion.activo.recorridos;
          html += `Se desvía del recorrido más de ${recorridos.distancia ?? 0} m`;
        }
        // Condicion Divergencia GPS
        if (dato.condicion?.activo?.divergenciaGPS) {
          html += 'Divergencia GPS sostenida';
        }
        break;
      }

      case 'Luminaria': {
        // Condicion Potencia
        if (dato.condicion?.luminaria?.potencia) {
          const potenciaSuperior =
            dato.condicion?.luminaria?.potencia['superior a'];
          const potenciaInferior =
            dato.condicion?.luminaria?.potencia['inferior a'];
          html += `Potencia superior al ${potenciaSuperior + 100}% o inferior al ${potenciaInferior}% del valor nominal`;
        }
        // Condicion Voltaje
        if (dato.condicion?.luminaria?.voltaje) {
          const voltajeSuperior =
            dato.condicion?.luminaria?.voltaje['superior a'];
          const voltajeInferior =
            dato.condicion?.luminaria?.voltaje['inferior a'];
          html += `Voltaje mayor a ${voltajeSuperior} V o inferior a ${voltajeInferior} V`;
        }
        break;
      }
      case 'Alarma': {
        // Condicion Llega evento
        if (dato.condicion?.alarma?.['llega evento']) {
          const codigo = dato.condicion?.alarma?.['llega evento'][0];
          html += `Llega evento ${escaparHtml(codigo)} - ${escaparHtml(dato.alarma?.modelo?.codigos?.codigos.find((c) => c.codigo === codigo)?.descripcion ?? '')}`;
        }
        // Condicion No Llega evento
        if (dato.condicion?.alarma?.['no llega evento']) {
          const codigo = dato.condicion?.alarma?.['no llega evento'][0];
          html += `No llega evento ${escaparHtml(codigo)} - ${escaparHtml(dato.alarma?.modelo?.codigos?.codigos.find((c) => c.codigo === codigo)?.descripcion ?? '')}`;
        }
        break;
      }
      default: {
        break;
      }
    }
    html += '</div>';
    return html;
  }

  private setearFiltros() {
    this.filtros.push(this.categoria);
    this.filtros.push(this.tipoEvento);
    this.filtros.push(this.tipoEntidad);
    this.filtros.push(this.activa);
    if (HelperService.getTipoCliente() !== 'Final') {
      this.filtros.push(this.cliente);
      this.filtros.push(this.ancestro);
    }
    if (this.helper.tieneModulo('Activos')) {
      this.filtros.push(this.activo);
    }
    if (this.helper.tieneModulo('Alarmas')) {
      this.filtros.push(this.alarma);
    }
    if (this.helper.tieneModulo('Vehículos')) {
      this.filtros.push(this.vehiculo);
    }
    if (this.helper.tieneModulo('Luminarias')) {
      this.filtros.push(this.luminaria);
    }
  }

  async ngOnInit(): Promise<void> {
    this.setColumnas();
    this.setearFiltros();
    if (this.params) {
      // Si se recibe el parametro desde el componente padre
      if (this.params.botonCrear) this.botonCrear.mostrar = true;
    } else {
      // Si se recibe el parametro desde la URL
      this.route.queryParams.subscribe((params) => {
        this.params = { ...this.params, ...(params as any) };
      });
      this.botonCrear.mostrar = true;
    }
    await this.listar();
  }

  ngOnDestroy(): void {
    this.datos$?.unsubscribe();
  }
}
